import state from '../initialState';

const initialState = {
  ...state,
};

export default initialState;
